(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7938],{

/***/ 27938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content080": function() { return /* binding */ Content080; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93590);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87367);
/* harmony import */ var _Content080_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90847);
/* harmony import */ var _Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var Content080 = function(param) {
    var payload = param.payload;
    var ref, ref1, ref2, ref3;
    var ref4;
    var title = (ref4 = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var description = (ref5 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var image = (ref6 = payload === null || payload === void 0 ? void 0 : payload.preview) !== null && ref6 !== void 0 ? ref6 : {};
    var ref7;
    var position = (ref7 = payload === null || payload === void 0 ? void 0 : payload.position) !== null && ref7 !== void 0 ? ref7 : "left";
    var ref8;
    var requestType = (ref8 = (ref = payload.button) === null || ref === void 0 ? void 0 : ref.type) !== null && ref8 !== void 0 ? ref8 : "form";
    var ref9;
    var form = (ref9 = (ref1 = payload.button) === null || ref1 === void 0 ? void 0 : ref1.form) !== null && ref9 !== void 0 ? ref9 : {};
    var ref10;
    var buttonText = (ref10 = (ref2 = payload.button) === null || ref2 === void 0 ? void 0 : ref2.buttonText) !== null && ref10 !== void 0 ? ref10 : "";
    var ref11;
    var requestLink = (ref11 = (ref3 = payload.button) === null || ref3 === void 0 ? void 0 : ref3.link) !== null && ref11 !== void 0 ? ref11 : "";
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("080", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY.CONTENT */ .R.CONTENT);
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    var ref12 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useToggle */ .OT)(), opened = ref12.opened, onOpen = ref12.onOpen, onClose = ref12.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().block), (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[position]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading4 */ .k8, {
                                className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
                                color: "light",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().description),
                                color: "light",
                                children: description
                            }),
                            requestType === "form" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Action */ .aU, {
                                onClick: onOpen,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                            color: "light",
                                            appearance: "bigger",
                                            children: buttonText
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                            className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                            name: "arrow_right"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .PageLink */ .H_, {
                                link: requestLink,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                            color: "light",
                                            appearance: "bigger",
                                            children: buttonText
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                            className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                            name: "arrow_right"
                                        })
                                    ]
                                })
                            }),
                            opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ModalWrapper */ .AB, {
                                onCloseModal: onClose,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                                    item: form,
                                    metaData: {
                                        page: query.slug
                                    },
                                    instanceId: instanceId,
                                    onReset: onClose
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().preview),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageLite */ .NH, {
                            image: image,
                            className: (_Content080_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content080);


/***/ }),

/***/ 90847:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content080_wrapper__nKk33","block":"Content080_block__iSh3O","preview":"Content080_preview__YWLOQ","image":"Content080_image__JV5j8","left":"Content080_left__SxAkE","right":"Content080_right__0XySd","content":"Content080_content__im95Y","title":"Content080_title__eP2bW","description":"Content080_description__9xgia","arrow":"Content080_arrow__8phXG","icon":"Content080_icon__wMfPF"};

/***/ })

}]);